




























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { NetworkSecurityInternetGeneralInformationData } from '@/modules/tickets/requirement/network-security-internet/domain/network-security-internet-general-information';

@Component({
    name: 'network-security-internet-ticket-confirmation',
})
export default class NetworkSecurityInternetTicketConfirmation extends Vue {
    @Prop({ required: true })
    generalInformation!: NetworkSecurityInternetGeneralInformationData;

    private isFormValid: boolean = true;

    private isCreatingTicket: boolean = false;

    sendRequirementTicket() {
        this.$emit('sendRequirementTicket');
    }

    previousStep() {
        this.$emit('previousStep');
    }

    reset() {
        this.$emit('reset');
    }
}
